export default "__VITE_ASSET__DcxWX3qT__"